<template>
    <v-dialog :value="value" @input="$emit('input', $event)" width="400">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="$emit('input', false)" text>Batal</v-btn>
                <v-btn @click="$emit('ok')" :color="color" text :loading="loading">{{ okText }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },

        subtitle: {
            type: String,
        },

        color: {
            type: String,
            required: true,
        },

        okText: {
            type: String,
            required: true,
        },

        loading: {
            type: Boolean,
            required: true
        },

        value: {
            type: Boolean,
        }
    }
}
</script>
